import React, { useEffect, useRef } from 'react';
import { Button, ButtonPriority, Text, TextTypography, TPAComponentsProvider, } from 'wix-ui-tpa/cssVars';
import styles from './form-loading-error.scss';
import { useTranslation } from '@wix/form-fields';
import { DATA_HOOKS } from '../data-hooks';
const TextWithChildren = Text;
const FormLoadingError = ({ formId, onError, isMobile, isRTL, }) => {
    const { t } = useTranslation();
    const isError = useRef(false);
    useEffect(() => {
        if (!isError.current) {
            isError.current = true;
            onError === null || onError === void 0 ? void 0 : onError(new Error(`Couldn’t load the form: ${formId}`));
        }
        return () => {
            isError.current = false;
        };
    }, [formId, onError]);
    return (React.createElement(TPAComponentsProvider, { value: { mobile: isMobile, rtl: isRTL } },
        React.createElement("div", { className: styles.container, "data-hook": DATA_HOOKS.FORM_VIEWER_NO_FORM_ERROR, dir: isRTL ? 'rtl' : '' },
            React.createElement(TextWithChildren, { typography: TextTypography.smallTitle }, t === null || t === void 0 ? void 0 : t('error.could-not-load-form.title')),
            React.createElement(TextWithChildren, { typography: TextTypography.runningText }, t === null || t === void 0 ? void 0 : t('error.could-not-load-form.description')),
            React.createElement(Button, { className: styles.button, onClick: () => window.location.reload(), priority: ButtonPriority.primary }, t === null || t === void 0 ? void 0 : t('error.could-not-load-form.button.label')))));
};
export default FormLoadingError;
//# sourceMappingURL=form-loading-error.js.map